// extracted by mini-css-extract-plugin
export default {"bold":"styles_bold__zpxt-","dialogContent":"styles_dialogContent__KfBHf","dialogAction":"styles_dialogAction__sY7rj"};